module.exports = __webpack_public_path__ + "img/achievement2.a679738e.png";